export default {"src":"/_next/static/media/replace.0bbe5bf3.svg","height":24,"width":24};